import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
export function TestimonialSection() {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <span className="text-muted-foreground">“</span>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <p className="-ml-1.5 text-base text-zinc-100">{t0}cubic immediately improved our review process. PRs move faster and quality is up.<span className="text-muted-foreground">”</span></p>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="space-y-2 sm:flex-1">{t1}<div className="flex items-center gap-2"><div className="text-base text-zinc-100">Co-founder, Cal.com</div><div className="text-base text-muted-foreground">Peer Richelson</div></div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="mx-auto w-full max-w-3xl rounded-xl border border-border bg-[#101011] p-6"><div className="flex flex-col gap-6 text-left sm:flex-row sm:items-center sm:justify-between">{t2}<div className="shrink-0"><Image src="/peer-richelson-profile.png" alt="Peer Richelson profile picture" width={56} height={56} className="rounded-lg" /></div></div></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}